module.exports = __webpack_public_path__ + "img/Childhood Obesity.30925b4e.jpg";